var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3e5eb9",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "M.7 7.5H54v25H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b10c0c",
    d: "M.7 10H54v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m46.4 15.4-2.5.9 2.4.8 2.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.7 16h-35q-.4 0-.4.3t.4.3h35q.3 0 .4-.3 0-.3-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "m44.2 16.6.3-.3-.3-.3m-.3.6.3-.3-.3-.3m-.3.6.3-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m44.2 16.6.3-.3-.3-.3m-.3.6.3-.3-.3-.3m-.3.6.3-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m44 17.1-2.4.9 2.4.9 2.4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.4 17.7h-35q-.4 0-.4.3t.3.3h35.1q.3 0 .3-.3t-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "m41.9 18.3.3-.3-.3-.3m-.3.6.3-.3-.3-.3m-.3.6.3-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m41.9 18.3.3-.3-.3-.3m-.3.6.3-.3-.3-.3m-.3.6.3-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M51.2 19.6H3.5q-.5 0-.5.4 0 .3.5.4h47.7q.4 0 .4-.4 0-.3-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41.3 20c-2.8 2.9-6.6 8.6-14.2 8.6-6.7 0-11.5-5.7-14.3-8.6 2.8-2.9 7.6-8.6 14.3-8.6 7.6 0 11.4 5.7 14.2 8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26 14.4c.8.9.2 1.2 1 1.3.8 0 .4.9 1 .9s0 2 .5 2.7 1 .2 1 .7-1.4.4-1.4 2c0 1-1.2 1-1.2 1.6 0 .5 2.1.8 2.1 1.3s-2.4.4-2.5 1c0 .5 3.2.9 3.5 2.4-.5.1-1.9.3-3 .3-6.6 0-11.4-5.7-14.2-8.6 2.8-2.9 7.6-8.6 14.3-8.6 0 0-2 1.8-1 3m-7.6 4.8V17Zm1.3-2.2v2.2Zm1.4 0v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M18.5 19.2V17m1.3 0v2.2m1.4-2.2v2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.5 23v-2.2Zm1.3-2.2V23Zm1.4 0V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M18.5 23v-2.2m1.3 0V23m1.4-2.3V23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.6 19.2V17ZM24 17v2.2Zm1.4 0v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M22.6 19.2V17m1.4 0v2.2m1.4-2.2v2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.6 23v-2.2Zm1.4-2.2V23Zm1.4 0V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M22.6 23v-2.2m1.4 0V23m1.4-2.3V23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29 19.2V17Zm1.3-2.2v2.2Zm1.4 0v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M29 19.2V17m1.3 0v2.2m1.4-2.2v2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29 23v-2.2Zm1.3-2.2V23Zm1.4 0V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M29 23v-2.2m1.3 0V23m1.4-2.3V23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.1 19.2V17Zm1.4-2.2v2.2Zm1.4 0v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M33.1 19.2V17m1.4 0v2.2m1.4-2.2v2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.1 23v-2.2Zm1.4-2.2V23Zm1.4 0V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M33.1 23v-2.2m1.4 0V23m1.4-2.3V23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M48.2 19.7c-.4.7.3-.3 2.2 1a2 2 0 0 1 .6 1.2l-.2-.2.2 1q-.4-.1-.4-.4v1.1l-.3-.2v.9l-.3-.3-.3.7-.2-.2-.6 1-1.6-1.6q0 .3-.6.5c0-.7-.6-1.5-.3-2q-.3 0-.5.3a4 4 0 0 1 2.3-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "m46.6 23.4.4-.7q.3-.7.5-.7v.6q-.3.5-1 .8m1.2.8v-1.1q.3 0 .3.4t-.3.7m1 .6-.1-.8q-.3-.7-.1-.8.2 0 .3.6zm.9-2.7-.5-.3q-.4-.4-.5-.3t.3.4q.2.2.7.2m-.2 1.3q0-.3-.3-.5 0-.5-.3-.5v.5q.2.3.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M5.1 20.4V20c.1 0 .1.3.4.1v-.3l1.2.3c.3 0 1-.3 1.4.1q.4.6.2 1.5l-.2-.4v2l-.1-.2c-.2.5-.4.6-.4 1.2l-.1-.3c-.2.3-1.3.7-.9 1q-.6-.2-.7-.4l-.3.3c-.7-.3-.4-1-1-1.5l-.1.5-.3-1-.3.3-.2-1c-.2.1 0 0-.2.3.2-1.4 1-2.4 1.6-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "m4.3 22.6.4-.8q.3-.9.5-.9t-.1.8q-.2.6-.8 1m.7 1.1.2-.7q0-.8.2-.8t0 .6q.1.6-.4 1m.8.8.1-.8.1-.7q.2 0 .2.6 0 .4-.4 1M7.5 22l-.7-.6q-.6-.7-.7-.6-.2.1.3.6t1.2.6m-.2 1.3-.5-.7q-.2-.6-.5-.6l.2.6q.3.5.8.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.4 13c-.4.7.7-.3 2.4 1q.7.7.8 1.6l-1-.4s.8.7.8 1.6l-.5-.4.2 1-.5-.4c.2.4-.5 1.3-.1 1.6a2 2 0 0 1-1.5-1l-.2.4s-1-.7-.8-1l-.2.5q-.6-.5-.8-1.1l-.3.4c-.2-.8-.2-.7 0-1.4q0 .3-.4.4a4 4 0 0 1 2.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "m21.5 16.7.2-1q0-1 .2-1.1.3 0 .2.8 0 .7-.6 1.3m1 1v-1.8q.3-.2.4.6 0 .6-.3 1.1m1.8.8-.5-.8q-.2-.7-.4-.7t0 .6q.3.6.9.8M25 15l-1-.4q-.9-.6-1-.4-.2.2.6.6.6.2 1.4.2m.2 1.4-.8-.5-.7-.5q-.2.2.3.6c.5.3.6.4 1.2.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.708b564a60eb0524bcd172142347937b.svg";
export { ForwardRef as ReactComponent };